import React, { useState } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import "../../../style/ModalForm.css"

const TenantModal = ({ show, onHide, onSave, formData, handleInputChange, currentTenant }) => {
    const [error, setError] = useState("");

    const handleSave = () => {
        if (!formData.name.trim()) {
            setError("Name is required.");
            return;
        }
        setError(""); // Clear any previous errors
        onSave();
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="custom-modal">
            <Modal.Header closeButton>
                <Modal.Title>{currentTenant ? "Edit Tenant" : "Add Tenant"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Enter tenant name (unique identifier)"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            type="text"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="Enter tenant description"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TenantModal;